// FLAGS: none
// Read-only summary card for one session — client name, date, type, expert, language — all from props.
import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Paper } from "@mui/material";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import PsychologyOutlinedIcon from "@mui/icons-material/PsychologyOutlined";
import EventIcon from "@mui/icons-material/Event";
import {
  formatClientName,
  formatSessionDateForSessionDetails,
  formatSessionType,
} from "@src/utils/formatter";
import { getConsultType } from "@src/utils/helpers";
import { IconSessionType } from "@src/components/Icons/IconSessionType";
import { IconSessionLanguage } from "@src/components/Icons/IconSessionLanguage";
import { ResponseConsultsConsultWithNotesResponse } from "@src/api/v1/data-contracts";

interface SessionDetailsPaperProps {
  consult: ResponseConsultsConsultWithNotesResponse;
}

const SessionDetailsPaper: React.FC<SessionDetailsPaperProps> = ({
  consult,
}) => {
  const { t } = useTranslation();
  const boxClass = "flex items-center mb-4 gap-3";

  return (
    <Paper className="w-[264px] py-3 px-2.5" data-cy="client-sessions-details">
      <h5 className="h5 mb-2">{t("Client.Sessions.Details")}</h5>

      <Box className={boxClass}>
        <PersonOutlinedIcon />
        <p className="body2">{formatClientName(consult.user)}</p>
      </Box>

      <Box className={boxClass}>
        <EventIcon />
        <p className="body2">{formatSessionDateForSessionDetails(consult)}</p>
      </Box>

      <Box className={boxClass}>
        <IconSessionType consultType={getConsultType(consult)} />
        <p className="body2">{formatSessionType(getConsultType(consult))}</p>
      </Box>

      <Box className={boxClass}>
        <PsychologyOutlinedIcon />
        <p className="body2">{consult.employeeFullName}</p>
      </Box>

      <Box className={boxClass}>
        <IconSessionLanguage
          language={consult.consultLanguage}
          className="h-7"
        />
        <p className="body2">
          {t(`SessionLanguage.${consult.consultLanguage}`)}
        </p>
      </Box>
    </Paper>
  );
};

export default SessionDetailsPaper;
